export default {
  // The view's own strings live in metal/MetalView.translations.ts; what's left here is
  // the panel-only chrome. Wording mirrors `article_detail_extend` deliberately — same
  // control, same promise — under its own id so either can be reworded alone.
  extendLabel: {
    id: 'rm_metal_detail_extend',
    defaultMessage: 'Read in the extended view',
  },
} as const
